import { Box, Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';
import LearningEventCard from 'packages/kakapo-ui-application/pages/learning/components/LearningEventCard';
import SearchFieldBig from 'packages/kakapo-ui-kit/components/forms/controls/SearchFieldBig';
import Select from 'packages/kakapo-ui-kit/components/forms/controls/Select';
import EmptyStateCard from 'packages/kakapo-ui-kit/components/cards/EmptyStateCard';

const LearningEventsList = (props: { events: graphql.LearningEventConnection }) => {
	const { t } = useTranslation();

	return (
		<Box flex={1}>
			<Flex mb={3} ml={-3} flexWrap="wrap" alignItems="stretch">
				{props.events.edges.length === 0 ? (
					<EmptyStateCard title={t('learning.events.empty')} />
				) : (
					props.events.edges.map(({ node }) => (
						<Box width={1 / 3} pl={3} mb={3} key={node.id}>
							<LearningEventCard event={node} />
						</Box>
					))
				)}
			</Flex>
		</Box>
	);
};

export const LearningEventsListHeader = () => {
	const { t } = useTranslation();

	return (
		<Flex alignItems="center">
			<Box width={[7 / 12, 3 / 4]} pr={3}>
				<SearchFieldBig placeholder={t('learning.events.search.placeholder')} />
			</Box>

			<Box width={[5 / 12, 1 / 4]}>
				<Select
					unspaced
					options={[
						{
							label: t('learning.events.sort.byDate'),
							value: 'sort_by_date',
						},
					]}
					onChange={(selectedOption: any) => {}}
					value={{ label: t('learning.events.sort.byDate'), value: 'sort_by_date' }}
				/>
			</Box>
		</Flex>
	);
};

export default LearningEventsList;
